import { render, staticRenderFns } from "./ProductAttributeRow.vue?vue&type=template&id=b1b041a0&scoped=true&"
import script from "./ProductAttributeRow.vue?vue&type=script&lang=js&"
export * from "./ProductAttributeRow.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributeRow.vue?vue&type=style&index=0&id=b1b041a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b041a0",
  null
  
)

export default component.exports